import { Autocomplete, Box, Button, Divider, IconButton, TextField, Typography } from '@mui/material';
import { FileIcon, FolderIcon, MenuVerticalIcon, PlusIcon, UploadFileIcon } from '~/assets/icons';
import styles from './File.module.scss';
import classNames from 'classnames/bind';
import { BaseHeaderTitle, BaseImage, BaseRow } from '~/components/common';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { ICustomer, ICustomerFile } from '~/utils/interface/customer';
import { catchError, handleApiError, notify } from '~/utils/helper';
import { customerActions } from '~/thunks/customer/customerSlice';
import usePermission from '~/hooks/usePermission';
import MenuOptionFolder from '~/components/customer/menu-option/MenuOption';
import ModalAlertDeleteFolder from '~/components/common/modal-alert-delete/ModalAlertDelete';
import { PERMISSIONS } from '~/utils/constants/permission';
import { DIALOG_MODE_CREATE, DIALOG_MODE_EDIT } from '~/utils/constants/common';
import EditFolderDialog from './edit-folder-dialog/EditFolderDialog';
import folderApi from '~/apis/folder';
import { IFolder, IParamGetFileFromFolder, IPayloadDeleteFolder } from '~/utils/interface/folder';
import { handleGetCustomerFolders } from '~/thunks/customer/customerThunk';
import UploadFileDialog from '~/components/common/upload-file-dialog/UploadFileDialog';
import { CREATE_CUSTOMER_FILE } from '~/utils/constants/jobs';
import { OptionUploadFile } from '~/utils/types/common';
import { handleGetTags } from '~/thunks/tag/tagThunk';
import { handleGetFilesFromFolder } from '~/thunks/folder/folderThunk';
import BasePagination from '~/components/jobs/base-pagination/BasePagination';
import ModalAlertDelete from '~/components/common/modal-alert-delete/ModalAlertDelete';
import EditFileDialog from '~/components/jobs/edit-file-dialog/EditFileDialog';
import { IPayloadDeleteAccount } from '~/utils/interface/account';
import { handleGetFile } from '~/thunks/file/fileThunk';
import MenuOption from '~/components/customer/menu-option/MenuOption';
import { ITag } from '~/utils/interface/tag';
import customerApi from '~/apis/customer';
import { folderActions } from '~/thunks/folder/folderSlice';
import fileApi from '~/apis/file';
import { IJobFile } from '~/utils/interface/job';
import ModalDownloadFile from '~/pages/admin/jobs/job-detail/components/File/modal-download-file/ModalDownloadFile';

const cx = classNames.bind(styles);
type FileProps = {
  data: ICustomer | undefined;
  id?: string;
};

const File = (props: FileProps) => {
  const { data, id } = props;
  const dayjs = require('dayjs');
  const { t } = useTranslation('admin/customer');
  const dispatch = useAppDispatch();
  const {
    openAlertDeleteFolder,
    menuSelectedFolderId,
    filterFolder,
    folders,
    selectedFolderIds,
    needRefreshData,
    filterFile,

    openAlertDelete,

    selectedIds,
  } = useAppSelector((state) => state.customer);
  const { files, totalPages, currentPage } = useAppSelector((state) => state.folder);
  const { tags } = useAppSelector((state) => state.tag);
  const [selectedTags, setSelectedTags] = useState<Array<ITag>>([]);
  const [anchorElFolder, setAnchorElFolder] = useState<null | HTMLElement>(null);
  const permissions = usePermission();
  const [openEditFolderDialog, setOpenEditFolderDialog] = useState<boolean>(false);
  const [editFolderDialogMode, setEditFolderDialogMode] = useState<string>('');
  const [editDataFolder, setEditDataFolder] = useState<string>();
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState<IFolder>();
  const [openEditFileDialog, setOpenEditFileDialog] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [editFileData, setEditFileData] = useState<ICustomerFile>();
  const [menuSelectedId, setMenuSelectedId] = useState<string | undefined>(undefined);
  const [isOpenModalDownloadFile, setIsOpenModalDownloadFile] = useState(false);
  const [fileDownload, setFileDownload] = useState<IJobFile>();
  const optionUploadFile: OptionUploadFile = {
    uploadFile: true,
    selectFromProject: false,
  };

  useEffect(() => {
    data?.id &&
      dispatch(handleGetCustomerFolders({ id: data?.id, data: filterFolder }))
        .unwrap()
        .catch((e) => {
          handleApiError(e);
        });
  }, [dispatch, data, filterFolder, needRefreshData]);

  const handleSetOpen = async (open: boolean, needRefreshData?: boolean) => {
    setOpenEditFolderDialog(open);
    setEditFolderDialogMode('');
    if (needRefreshData) dispatch(customerActions.changeNeedRefreshData(true));
  };

  const openOptionMenuFolder = (event: React.MouseEvent<HTMLButtonElement>, itemId?: string) => {
    setAnchorElFolder(event.currentTarget);
    dispatch(customerActions.changeMenuSelectFolderId(itemId));
  };
  const openOptionMenu = (event: React.MouseEvent<HTMLButtonElement>, itemId: number) => {
    dispatch(folderActions.changeFileId(String(itemId)));

    setAnchorEl(event.currentTarget);
    setMenuSelectedId(String(itemId));
  };

  const handleCloseFolder = () => {
    setAnchorElFolder(null);
  };
  const handleChangePage = (event: unknown, newPage: number) => {
    dispatch(
      customerActions.setFilterFile({
        page: newPage,
      })
    );
  };

  const handleDeleteItemFolder = () => {
    handleCloseFolder();
    dispatch(customerActions.changeOpenAlertDeleteFolder(true));
  };

  const handleSetOpenEditFileDialog = async (value: boolean, needRefreshData?: boolean | undefined) => {
    setOpenEditFileDialog(value);
    needRefreshData && (await dispatch(customerActions.changeNeedRefreshData(needRefreshData)));
  };

  const handleEditItemFolder = () => {
    handleCloseFolder();
    setEditFolderDialogMode(DIALOG_MODE_EDIT);
    setOpenEditFolderDialog(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditItem = async () => {
    handleClose();
    if (menuSelectedId) {
      const file = files.filter((file, index) => file.id === menuSelectedId);
      const fileId = file[0].fileId;

      if (fileId) {
        const response = await dispatch(handleGetFile({ id: fileId })).unwrap();
        setEditFileData(response);
        setOpenEditFileDialog(true);
      }
    }
  };

  const handleDeleteItem = () => {
    handleClose();
    dispatch(customerActions.changeOpenAlertDelete(true));
  };

  const closeAlertDeleteModalFolder = useCallback(() => {
    dispatch(customerActions.changeOpenAlertDeleteFolder(false));
  }, [dispatch]);

  const closeAlertDeleteModal = useCallback(() => {
    dispatch(customerActions.changeOpenAlertDelete(false));
  }, [dispatch]);

  const handleCreateFolder = async () => {
    setEditFolderDialogMode(DIALOG_MODE_CREATE);
    setOpenEditFolderDialog(true);
  };

  const onDeleteSelectedFolders = async () => {
    const payloadDeleteFolders: IPayloadDeleteFolder =
      menuSelectedFolderId !== undefined ? { ids: [menuSelectedFolderId] } : { ids: [...selectedFolderIds] };
    try {
      await folderApi.deleteFolder(payloadDeleteFolders);
      dispatch(customerActions.changeNeedRefreshData(true));
      dispatch(customerActions.changeOpenAlertDeleteFolder(false));
      notify('success', t('deleteSuccessMessage'));
    } catch (e: unknown) {
      catchError(e, (message) => {
        notify('error', message);
      });
    }
  };
  const onDeleteSelectedJobs = async () => {
    const payloadDeleteAccounts: IPayloadDeleteAccount =
      menuSelectedId !== undefined ? { ids: [menuSelectedId] } : { ids: [...selectedIds] };

    try {
      await customerApi.deleteFiles(data?.id, payloadDeleteAccounts);
      await dispatch(customerActions.changeNeedRefreshData(true));
      await dispatch(customerActions.changeOpenAlertDelete(false));
      notify('success', t('deleteSuccessMessage'));
    } catch (e: unknown) {
      catchError(e, (message) => {
        notify('error', message);
      });
    }
  };
  const handleSelectedTags = (values: ITag[]) => {
    setSelectedTags(values);
    dispatch(
      customerActions.setFilterFile({
        page: 1,
        selectedTags: values.map((index, key) => index.id),
      })
    );
  };
  useEffect(() => {
    folders && !selectedFolder && setSelectedFolder(folders[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folders]);
  useEffect(() => {
    selectedFolder &&
      data?.id &&
      dispatch(
        handleGetFilesFromFolder({
          id: selectedFolder.id,
          params: { ...filterFile, ...{ type: 'customerFile', typeId: data.id } } as any as IParamGetFileFromFolder,
        })
      )
        .unwrap()
        .catch((e) => {
          handleApiError(e);
        });
  }, [dispatch, data, filterFile, needRefreshData, selectedFolder]);

  useEffect(() => {
    dispatch(handleGetTags()).unwrap();
  }, [dispatch]);

  const handleCloseModalDownloadFile = () => {
    setIsOpenModalDownloadFile(false);
  };

  const handleDownloadFile = async (fileSelected: any) => {
    handleClose();
    if (fileSelected) {
      const file = files.filter((file, index) => file.id === fileSelected.id);
      const fileId = file[0].fileId;
      if (fileId) {
        const response = await dispatch(handleGetFile({ id: fileId })).unwrap();
        setFileDownload(response);
        setIsOpenModalDownloadFile(true);
      }
    }
  };

  const handleDownload = async () => {
    handleClose();
    if (menuSelectedId) {
      const file = files.filter((file, index) => file.id === menuSelectedId);
      const fileId = file[0].fileId;
      if (!fileId) {
        return;
      }
      const result = await fileApi.downloadFileUrl(fileId);
      const fileUrl = result?.data?.data?.fileUrl;
      if (result?.data?.data?.fileUrl) {
        const anchor = document.createElement('a');
        anchor.href = String(fileUrl);
        anchor.download = result?.data?.data?.name ?? '';
        anchor.click();
      }
    }
  };

  return (
    <BaseRow className='gap-[30px]'>
      <Box className='lg:w-[30%]'>
        <Box className='w-full text-end mb-[10px]'>
          <Button
            className='h-[36px] px-[12px] py-[9.5px] text-[14px]/[16.8px] font-medium rounded-lg w-full'
            variant='outlined'
            size='large'
            startIcon={<UploadFileIcon className='w-[12px] h-[12px]' />}
            onClick={() => setOpenUploadFile(true)}
          >
            {t('uploadFile', { ns: 'admin/common' })}
          </Button>
        </Box>
        <Box className='flex flex-row mb-[30px]'>
          <BaseHeaderTitle title={t('titleFolder')} />
          <Box>
            {permissions[PERMISSIONS.organizationFile_create] && (
              <Button
                className='h-[36px] px-[14px] py-[9.5px] text-[14px]/[16.8px] font-medium rounded-lg ml-[10px]'
                variant='contained'
                disableElevation
                startIcon={<PlusIcon className='w-[10px] h-[10px]' />}
                onClick={handleCreateFolder}
              >
                {t('addFolder')}
              </Button>
            )}
          </Box>
        </Box>
        <Box className={cx('folder-container')}>
          {permissions[PERMISSIONS.organizationFile_view] &&
            folders?.map((folder, index) => (
              <Box className={cx('folderContent')} key={index}>
                <Box
                  className={cx(
                    'folderItem',
                    {
                      active: selectedFolder && folder.id === selectedFolder.id,
                    },
                    ' hover:bg-stone-100 cursor-pointer'
                  )}
                  onClick={() => {
                    dispatch(customerActions.setFilterFile({ page: 1 }));
                    setSelectedFolder(folder);
                  }}
                >
                  <FolderIcon className='w-[20px] h-[20px] folderIcon' />
                  <Typography className={cx('folderName')}>{folder?.name}</Typography>
                  {folder?.targetType !== 'companies' && (
                    <Box className={cx('folderAction')}>
                      <IconButton
                        onClick={(event) => {
                          openOptionMenuFolder(event, folder.id);
                          dispatch(customerActions.changeMenuSelectFolderId(folder?.id));
                          setEditDataFolder(folder.name);
                        }}
                      >
                        <MenuVerticalIcon className='w-[18px] h-[18px]' />
                      </IconButton>
                    </Box>
                  )}
                </Box>
                <Divider className={cx('lineFolder')} />
              </Box>
            ))}
        </Box>
        <Box>
          <Box className='pb-[15px]'>
            <Typography className='my-[15px]'>{t('tags')}</Typography>
            <Autocomplete
              multiple
              disableClearable
              value={selectedTags || []}
              onChange={(event, newValue) => handleSelectedTags(newValue)}
              options={tags}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              popupIcon={null}
              disableCloseOnSelect
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant='outlined'
                  placeholder={t('searchPlaceholder')}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      paddingTop: 0,
                      paddingBottom: 0,
                    },
                  }}
                />
              )}
            />
          </Box>
        </Box>
      </Box>
      <Box className='lg:w-[70%]'>
        <Box className={cx('file-container')}>
          <Typography variant='h6' gutterBottom className={cx('title')}>
            {selectedFolder?.name}
          </Typography>

          <Box className={cx('box-file-container')}>
            <Box className={cx('box-file')}>
              {files?.map((file, index) => (
                <Box key={index} className={cx('file')}>
                  {(permissions[PERMISSIONS.organizationFile_edit] ||
                    permissions[PERMISSIONS.organizationFile_delete]) && (
                    <IconButton
                      className={cx('menuIcon')}
                      onClick={(event) => {
                        dispatch(folderActions.changeMenuSelectId(file?.id));

                        openOptionMenu(event, Number(file?.id));
                      }}
                    >
                      <MenuVerticalIcon className='w-[12px] h-[12px]' />
                    </IconButton>
                  )}

                  <Box onClick={() => handleDownloadFile(file)} className={cx('file-content')}>
                    {file?.type === 'IMAGE' ? (
                      <BaseImage src={file?.url} className={cx('image')} />
                    ) : (
                      <FileIcon className={cx('fileIcon')} />
                    )}

                    <Box>
                      <Typography className={cx('fileName')}>{file?.name}</Typography>
                    </Box>
                    <Divider className={cx('line')} />
                    <Box className={cx('create')}>
                      <Box className={cx('box-create')}>
                        <Typography variant='caption' className={cx('createBy')}>
                          {t('files.createdBy')}
                        </Typography>
                        <Typography variant='caption' className={cx('createByText')}>
                          {file.createdByAccount}
                        </Typography>
                      </Box>

                      <Box className={cx('box-create-at')}>
                        <Typography variant='caption' className={cx('createBy')}>
                          {t('files.createdAt')}
                        </Typography>
                        <Typography variant='caption' className={cx('createByText')}>
                          {dayjs(file.createdAt).format('MM/DD/YYYY')}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
            <Box className={cx('pagination')}>
              <BasePagination count={totalPages} page={currentPage} onChange={handleChangePage} />
            </Box>
            <ModalAlertDelete
              open={openAlertDelete}
              description={t('alertDescriptionFile')}
              onCancel={closeAlertDeleteModal}
              onConfirm={onDeleteSelectedJobs}
            />
            <EditFileDialog
              open={openEditFileDialog}
              id={props.id}
              data={editFileData}
              folders={folders}
              setOpen={handleSetOpenEditFileDialog}
            />
          </Box>
        </Box>
      </Box>
      <MenuOption
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        handleEditItem={handleEditItem}
        handleDeleteItem={handleDeleteItem}
        enableEdit={permissions[PERMISSIONS.contactFile_edit]}
        enableDelete={permissions[PERMISSIONS.contactFile_delete]}
        handleDownload={handleDownload}
      />
      <MenuOptionFolder
        anchorEl={anchorElFolder}
        open={Boolean(anchorElFolder)}
        onClose={handleCloseFolder}
        handleEditItem={handleEditItemFolder}
        handleDeleteItem={handleDeleteItemFolder}
        enableEdit={permissions[PERMISSIONS.contactFile_edit]}
        enableDelete={permissions[PERMISSIONS.contactFile_delete]}
      />

      <ModalDownloadFile open={isOpenModalDownloadFile} file={fileDownload} onClose={handleCloseModalDownloadFile} />

      <EditFolderDialog
        open={openEditFolderDialog}
        mode={editFolderDialogMode}
        setOpen={handleSetOpen}
        data={editDataFolder}
        id={id}
      />

      <ModalAlertDeleteFolder
        open={openAlertDeleteFolder}
        description={t('alertOrganizationFolder')}
        onCancel={closeAlertDeleteModalFolder}
        onConfirm={onDeleteSelectedFolders}
      />

      <UploadFileDialog
        customerId={props.id}
        open={openUploadFile}
        setOpen={(value: boolean) => setOpenUploadFile(value)}
        optionUploadFile={optionUploadFile}
        type={CREATE_CUSTOMER_FILE}
        uploadedToFolder={(value) => {
          const folder = folders.filter((folder, index) => folder.id === value);
          folder && setSelectedFolder(folder[0]);
          dispatch(customerActions.changeNeedRefreshData(true));
        }}
        data={filterFolder}
        shouldQueue={true}
        customer={props.data}
      />
    </BaseRow>
  );
};

export default File;
